import { slug } from '@magalu/mixer-utils';
var getContentId = function getContentId(content, type) {
  var actions = {
    "default": function _default() {
      return slug(content) || null;
    },
    login: function login() {
      return "login:".concat(slug(content) || null);
    },
    menu: function menu() {
      return "menu:".concat(slug(content) || null);
    },
    search: function search() {
      return "busca:".concat(content);
    },
    suggestion: function suggestion() {
      return "magalu-has:".concat(slug(content) || null);
    },
    zipcode: function zipcode() {
      return content ? "error:".concat(content) : 'sucesso:sucesso';
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var selectContentHeader = function selectContentHeader(content) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    content_id: getContentId(content, type),
    content_type: 'menu-superior',
    event: 'select_content'
  };
};
export default selectContentHeader;